module.exports = __webpack_public_path__ + "static/media/the-right-information-at-the-right-time-02@2x.bd59a429.png";